// University of Miami's undergraduate majors (#2652, round 2). Read on
// 2026-10-01 from the official 2026-2027 Academic Bulletin's Program Index
// (bulletin.miami.edu/program-index/), a table of every program with its
// school or college, level and plan: every row marked Undergraduate and
// Major kept, with the degree split from the program name as the Bulletin
// writes it (B.A., B.S., B.B.A., B.S.B.A., B.S.C., B.M., B.S.E.D., ...).
// "Bachelor of Architecture" and "Bachelor of General Studies" are shown as
// Architecture (B.Arch.) and General Studies (B.G.S.). Left out: rows that
// are minors, co-majors (Global Business, Sustainable Business), dual
// degrees, double-major pairings (Marine Science/X, Meteorology and X,
// Sociology and Criminology, Microbiology and Public Health) and the
// accelerated and five-year programs. The Bulletin's school names are
// normalized where it misspells them ("Arts and Science", "Arts amd
// Sciences", "Marine Atmospheric Science"). Physics B.S. options and the
// three Nursing BSN tracks are kept as the Bulletin lists them. 148 lines.
const majors = {
    "slug": "university-of-miami",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in the University of Miami's official 2026-2027 Academic Bulletin Program Index, grouped by the school or college the Bulletin names, with the degree it leads to. Minors, co-majors, dual-degree and accelerated programs, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Architecture",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                }
            ]
        },
        {
            "name": "Arts and Sciences",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art - General Study",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry Certified",
                    "degree": "B.S."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Criminology",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science and Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science and Artificial Intelligence",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Ecosystem Science and Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Ecosystem Science and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "Global Health Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Health Studies",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Independent Major",
                    "degree": "B.A."
                },
                {
                    "name": "Independent Major",
                    "degree": "B.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Arts",
                    "degree": "B.L.A."
                },
                {
                    "name": "Materials Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology and Immunology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics - Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Chemistry/Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Engineering/Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Marine Science/Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics - Pure Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Religion and Health Care",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "Business",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Accounting",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Accounting and Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence Technologies for Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Artificial Intelligence Technologies for Business",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Business Technology",
                    "degree": "B.B.A."
                },
                {
                    "name": "Business Technology",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.B.A."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Health Management and Policy",
                    "degree": "B.B.A."
                },
                {
                    "name": "Health Management and Policy",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Human Resources Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Human Resources Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Individualized General Business",
                    "degree": "BBA"
                },
                {
                    "name": "Individualized General Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.B.A."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "B.B.A."
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.B.A."
                },
                {
                    "name": "Real Estate",
                    "degree": "B.S.B.A."
                },
                {
                    "name": "Supply Chain Analytics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Supply Chain Analytics",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "Communication",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.S.C."
                },
                {
                    "name": "Broadcast Journalism",
                    "degree": "B.S.C."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.S.C."
                },
                {
                    "name": "Digital Storytelling and Content Creation",
                    "degree": "B.S.C."
                },
                {
                    "name": "Human-Centered Design & Computing",
                    "degree": "B.S.C."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S.C."
                },
                {
                    "name": "Media Management",
                    "degree": "B.S.C."
                },
                {
                    "name": "Motion Pictures",
                    "degree": "B.S.C."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S.C."
                }
            ]
        },
        {
            "name": "Continuing and International Education",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "General Studies",
                    "degree": "B.G.S."
                }
            ]
        },
        {
            "name": "Education and Human Development",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Applied Physiology",
                    "degree": "B.S."
                },
                {
                    "name": "Community and Applied Psychological Studies",
                    "degree": "B.S.E.D."
                },
                {
                    "name": "Data Analytics and Intelligence for Social Impact",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary/Exceptional Student Education (with ESOL and Reading Endorsements)",
                    "degree": "B.S.E.D."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.S.E.D."
                },
                {
                    "name": "Sports Medicine",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Engineering",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.C.p.E."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Engineering Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Innovation, Technology and Design",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Marine and Atmospheric Science",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Geological Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "Geological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Marine Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Marine Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Marine Science (with a second major)",
                    "degree": "B.S."
                },
                {
                    "name": "Meteorology",
                    "degree": "B.S."
                },
                {
                    "name": "Oceanography",
                    "degree": "B.S."
                }
            ],
            "note": "The Bulletin also lists Marine Science paired with Biology, Chemistry, Computer Science, Geological Sciences, Microbiology and Immunology, or Physics, and Meteorology paired with Marine Science or Mathematics, as double majors; they are not listed separately here."
        },
        {
            "name": "Music",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Audio Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Bachelor of Arts in Music",
                    "degree": "B.A.M."
                },
                {
                    "name": "Instrumental Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Keyboard Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Media Scoring and Production",
                    "degree": "B.M."
                },
                {
                    "name": "Modern Artist Development and Entrepreneurship",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education (with Minor in Education)",
                    "degree": "B.M."
                },
                {
                    "name": "Music Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Music Industry",
                    "degree": "B.A."
                },
                {
                    "name": "Music Industry",
                    "degree": "B.M."
                },
                {
                    "name": "Music Theory and Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Music Therapy (with Minor in Psychology)",
                    "degree": "B.M."
                },
                {
                    "name": "Professional Studies",
                    "degree": "B.M."
                },
                {
                    "name": "Studio Music and Jazz Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Studio Music and Jazz Voice",
                    "degree": "B.M."
                },
                {
                    "name": "Vocal Performance",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "Nursing and Health Studies",
            "source": {
                "label": "University of Miami 2026-2027 Academic Bulletin, Program Index",
                "url": "https://bulletin.miami.edu/program-index/"
            },
            "majors": [
                {
                    "name": "Health Science",
                    "degree": "BSHS"
                },
                {
                    "name": "Nursing - Accelerated",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - RN-BSN",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing - Traditional",
                    "degree": "BSN"
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
